<template>
  <div class="roleMain">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <el-input
            style="width: 150px"
            placeholder="菜单名称"
            v-model.trim="queryData.name"
            @keyup.enter.native="getDataList(true)"
            clearable
          >
          </el-input>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button type="primary" @click="addOrEditPopup(0)"
            >新增菜单</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        :tree-props="{ children: 'list' }"
        row-key="menuId"
      >
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="name" label="菜单名称" min-width="180">
        </el-table-column>
        <el-table-column prop="url" label="路由地址" min-width="180">
          <template slot-scope="scope">
            <p>{{ scope.row.url || "无" }}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="icon" label="图标" min-width="180">
          <template slot-scope="scope">
            <img class="menuIcon" :src="scope.row.icon" alt="" />
          </template>
        </el-table-column> -->
        <el-table-column prop="perms" label="权限" min-width="180">
          <template slot-scope="scope">
            <p>{{ scope.row.perms || "无" }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" label="排序" min-width="180">
        </el-table-column
        ><el-table-column fixed="right" label="操作" min-width="160">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="addOrEditPopup(scope.row.menuId)"
              style="marin-right: 20px"
              >编辑</el-button
            >

            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.menuId)"
              >删除</el-button
            >
            <span class="operationLine">|</span>
            <el-button
              v-if="scope.row.parentId == 0"
              type="text"
              @click="addOrEditPopup('', scope.row.menuId, 1)"
              >添加菜单</el-button
            >
            <el-button
              type="text"
              @click="addOrEditPopup('', scope.row.menuId, 2)"
              v-if="scope.row.url"
              >添加按钮</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      :title="dataForm.menuId ? '修改' : '新增'"
      :visible.sync="centerDialogVisible"
      width="800px"
      center
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="90px"
        :rules="dataFormRules"
      >
        <el-form-item prop="type" label="类型">
          <el-radio-group v-model="dataForm.type">
            <el-radio :label="0">目录</el-radio>
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="name"
          :label="
            dataForm.type == 0
              ? '目录名称'
              : dataForm.type == 1
              ? '菜单名称'
              : '按钮名称'
          "
        >
          <el-input v-model.trim="dataForm.name"></el-input>
        </el-form-item>
        <el-form-item label="菜单地址" v-if="dataForm.type == 1">
          <el-input v-model.trim="dataForm.url"></el-input>
        </el-form-item>

        <el-form-item label="权限" v-if="dataForm.type == 2">
          <el-input v-model.trim="dataForm.perms"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            :min="1"
            placeholder="排序"
            v-model.trim="dataForm.orderNum"
          ></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="目录图标" v-if="dataForm.type == 0">
          <el-upload
            class="avatar-uploader"
            :action="`${$store.state.uploadImgUrl}?access_token=${$store.state.access_token}`"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :on-error="this.$uploadError"
            :before-upload="this.$beforeUploadImage"
            accept="image/*"
          >
            <img
              v-if="dataForm.icon"
              :src="dataForm.icon"
              class="avatar"
              style="background-color: #ccc"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        name: "",
      },
      total: 0,
      centerDialogVisible: false,
      dataForm: {},
      dataFormRules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        // url: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
      loadingFlag: false,
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    /**新增**/
    addOrEditPopup(id, menuId, type) {
      this.centerDialogVisible = true;
      if (id) {
        this.$http.get(`sys-menu/baseGetById/${id}`).then((res) => {
          this.dataForm = res.data.data;
        });
      } else {
        if (menuId) {
          this.dataForm = {
            type: type,
            parentId: menuId,
          };
        } else {
          this.dataForm = {
            type: 0,
          };
        }
      }
    },

    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .delete(`sys-menu/baseDeleteById/${id}`)
              // .delete(`admin/sys-menu/baseDeleteById/${id}`)
              .then((res) => {
                if (res.data.code == 200) {
                  this.getDataList();
                  this.$VueMessage({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$VueMessage({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 查询
    getDataList(flag) {
      // let _that=this;
      // setInterval(function(){
      //   _that
      // },100)
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        .get(`/sys-menu/getSelectPage`, {
          params: data,
        })
        // .get(`admin/sys-menu/getSelectPage`, {
        //   params: data,
        // })
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            let list = data.records;
            this.tableData = list;
            this.total = data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },
    /**
     * 上传图片成功
     */
    uploadSuccess(res) {
      this.$store.state.beforeUploadLoading.close();
      this.$set(this.dataForm, "icon", res.data);
    },
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "sys-menu/saveOrUpdate";
          // let url = "admin/sys-menu/saveOrUpdate";
          let data = this.dataForm;
          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.getDataList();
              // this.$emit("refreshDataList");
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.roleMain {
  .menuIcon {
    height: 30px;
    background-color: #ccc;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 16px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
}
</style>
